//This is used by Charm embedded configurator, so the history only works between where the user started and going forward only.
export default ({ app }, inject) => {
  const internalHistory = [];
  let isGoingBack = false;

  app.router.afterEach((to, from) => {
    if (!isGoingBack && from.name) {
      internalHistory.push(from.fullPath); // Track history in-app
    }
    isGoingBack = false;
  });

  // Inject the history array and custom back function globally
  inject("internalHistory", internalHistory);
  inject("goBack", () => {
    if (internalHistory.length > 0) {
      const lastRoute = internalHistory.pop();
      isGoingBack = true;
      app.router.push(lastRoute);
    } else {
      console.log("No more pages to go back to within the app.");
    }
  });
};
